import add from './add';
import add_send from './add_send';
import add_solid from './add_solid';
import archive from './archive';
import arrow_down from './arrow_down';
import arrow_left from './arrow_left';
import arrow_right from './arrow_right';
import arrow_up from './arrow_up';
import asterisk from './asterisk';
import autofill from './autofill';
import blocks from './blocks';
import book from './book';
import calendar from './calendar';
import calendar_add from './calendar_add';
import calendar_edit from './calendar_edit';
import checklist from './checklist';
import checkmark from './checkmark';
import checkmark_small from './checkmark_small';
import clients from './clients';
import clients_solid from './clients_solid';
import close from './close';
import close_small from './close_small';
import combine from './combine';
import company from './company';
import compose_message from './compose_message';
import convert from './convert';
import copy from './copy';
import corporate from './corporate';
import credit_card from './credit_card';
import danger from './danger';
import disabled from './disabled';
import disabled_checkbox from './disabled_checkbox';
import document from './document';
import document_approve from './document_approve';
import document_cancel from './document_cancel';
import document_export from './document_export';
import document_rejected from './document_rejected';
import document_send from './document_send';
import dot_horizontal from './dot_horizontal';
import dot_menu from './dot_menu';
import download from './download';
import duplicate from './duplicate';
import edit from './edit';
import edit_list from './edit_list';
import enabled from './enabled';
import enabled_checkbox from './enabled_checkbox';
import error from './error';
import error_solid from './error_solid';
import expand from './expand';
import favorite from './favorite';
import favorite_solid from './favorite_solid';
import filter from './filter';
import first_arrow from './first_arrow';
import folder from './folder';
import folder_open from './folder_open';
import free from './free';
import hide from './hide';
import history from './history';
import home from './home';
import import_presets from './import_presets';
import inbox from './inbox';
import info from './info';
import info_solid from './info_solid';
import language from './language';
import last_arrow from './last_arrow';
import license from './license';
import lightbulb from './lightbulb';
import links from './links';
import logout from './logout';
import mail from './mail';
import mail_point from './mail_point';
import members from './members';
import mention from './mention';
import message from './message';
import mid_arrow_down from './mid_arrow_down';
import mid_arrow_up from './mid_arrow_up';
import minimize from './minimize';
import minus from './minus';
import notification from './notification';
import open_blank from './open_blank';
import payment from './payment';
import payment_cancel from './payment_cancel';
import payment_complete from './payment_complete';
import pdf from './pdf';
import plus from './plus';
import question from './question';
import question_solid from './question_solid';
import report from './report';
import search from './search';
import secure_send from './secure_send';
import send from './send';
import send_cancel from './send_cancel';
import send_complete from './send_complete';
import sending_history from './sending_history';
import settings from './settings';
import show from './show';
import slider_handle from './slider_handle';
import small_arrow_down from './small_arrow_down';
import small_arrow_left from './small_arrow_left';
import small_arrow_right from './small_arrow_right';
import small_arrow_up from './small_arrow_up';
import sort_ascending from './sort_ascending';
import sort_descending from './sort_descending';
import spinner from './spinner';
import subtract from './subtract';
import subtract_solid from './subtract_solid';
import success from './success';
import success_solid from './success_solid';
import tag from './tag';
import transaction from './transaction';
import trash from './trash';
import tutorial from './tutorial';
import upload from './upload';
import user from './user';
import user_solid from './user_solid';
import warning from './warning';
import warning_solid from './warning_solid';

export default {
    add,
    add_send,
    add_solid,
    archive,
    arrow_down,
    arrow_left,
    arrow_right,
    arrow_up,
    asterisk,
    autofill,
    blocks,
    book,
    calendar,
    calendar_add,
    calendar_edit,
    checklist,
    checkmark,
    checkmark_small,
    clients,
    clients_solid,
    close,
    close_small,
    combine,
    company,
    compose_message,
    convert,
    copy,
    corporate,
    credit_card,
    danger,
    disabled,
    disabled_checkbox,
    document,
    document_approve,
    document_cancel,
    document_export,
    document_rejected,
    document_send,
    dot_horizontal,
    dot_menu,
    download,
    duplicate,
    edit,
    edit_list,
    enabled,
    enabled_checkbox,
    error,
    error_solid,
    expand,
    favorite,
    favorite_solid,
    filter,
    first_arrow,
    folder,
    folder_open,
    free,
    hide,
    history,
    home,
    import_presets,
    inbox,
    info,
    info_solid,
    language,
    last_arrow,
    license,
    lightbulb,
    links,
    logout,
    mail,
    mail_point,
    members,
    mention,
    message,
    mid_arrow_down,
    mid_arrow_up,
    minimize,
    minus,
    notification,
    open_blank,
    payment,
    payment_cancel,
    payment_complete,
    pdf,
    plus,
    question,
    question_solid,
    report,
    search,
    secure_send,
    send,
    send_cancel,
    send_complete,
    sending_history,
    settings,
    show,
    slider_handle,
    small_arrow_down,
    small_arrow_left,
    small_arrow_right,
    small_arrow_up,
    sort_ascending,
    sort_descending,
    spinner,
    subtract,
    subtract_solid,
    success,
    success_solid,
    tag,
    transaction,
    trash,
    tutorial,
    upload,
    user,
    user_solid,
    warning,
    warning_solid,
};
